import { Apis, ApiSubUrls } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchBrandsTrends = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/brands/trends/`,
)
